import { createContext } from "react";

const MultiViewContext = createContext();

export default MultiViewContext;
